module.exports = __webpack_public_path__ + "static/media/cateModa.7d6d5cc8.jpg";